export const add = (a, b) => ({ x: a.x + b.x, y: a.y + b.y, z: a.z + b.z });
export const subtract = (a, b) => ({ x: a.x - b.x, y: a.y - b.y, z: a.z - b.z });
export const scale = (v, n) => ({ x: v.x * n, y: v.y * n, z: v.z * n });
export const dot = (a, b) => a.x * b.x + a.y * b.y + a.z * b.z;
export const length = (v) => Math.hypot(v.x, v.y, v.z);
export const distance = (a, b) => length(subtract(a, b));
export const normalize = (v) => {
    const magnitude = length(v);
    return magnitude > 1e-9 ? scale(v, 1 / magnitude) : { x: 0, y: 0, z: -1 };
};
export const lerpVec3 = (a, b, t) => add(a, scale(subtract(b, a), t));
export const clamp = (value, min, max) => Math.min(max, Math.max(min, value));
/** The server expands one aim ray into a dispersed, evenly spaced pellet pattern. */
export function spreadRays(aim, pellets, spreadRadians, rotation) {
    const direction = normalize(aim.direction);
    const cross = (a, b) => ({ x: a.y * b.z - a.z * b.y, y: a.z * b.x - a.x * b.z, z: a.x * b.y - a.y * b.x });
    const right = normalize(cross(direction, Math.abs(direction.y) < 0.99 ? { x: 0, y: 1, z: 0 } : { x: 0, y: 0, z: 1 }));
    const up = cross(right, direction);
    return Array.from({ length: pellets }, (_, index) => {
        const radius = index === 0 ? 0 : Math.tan(spreadRadians) * Math.sqrt(index / (pellets - 1));
        const angle = rotation + index * Math.PI * (3 - Math.sqrt(5));
        return { origin: { ...aim.origin }, direction: normalize(add(direction, add(scale(right, Math.cos(angle) * radius), scale(up, Math.sin(angle) * radius)))) };
    });
}
/** Circular target hit test on a plane facing the firing line (normal +Z). */
export function rayTargetIntersection(ray, center, radius) {
    const direction = normalize(ray.direction);
    if (Math.abs(direction.z) < 1e-7)
        return null;
    const t = (center.z - ray.origin.z) / direction.z;
    if (t <= 0 || t > 300)
        return null;
    const point = add(ray.origin, scale(direction, t));
    const radial = Math.hypot(point.x - center.x, point.y - center.y);
    if (radial > radius)
        return null;
    return { distance: t, point, normalizedRadius: radial / radius };
}
export function ringMultiplier(normalizedRadius, thresholds, multipliers) {
    for (let index = 0; index < thresholds.length; index += 1) {
        if (normalizedRadius <= (thresholds[index] ?? 1))
            return multipliers[index] ?? 1;
    }
    return 1;
}
export const mulberry32 = (seed) => {
    let state = seed >>> 0;
    return () => {
        state += 0x6d2b79f5;
        let value = state;
        value = Math.imul(value ^ (value >>> 15), value | 1);
        value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
        return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
    };
};
export const hashSeed = (text) => {
    let hash = 2166136261;
    for (let index = 0; index < text.length; index += 1) {
        hash ^= text.charCodeAt(index);
        hash = Math.imul(hash, 16777619);
    }
    return hash >>> 0;
};
/** Shared camera origin for a player's adjacent firing lane. */
export const lanePosition = (lane) => ({ x: (lane - 3.5) * 1.5, y: 1.68, z: 3.6 });
//# sourceMappingURL=math.js.map